module.exports = __webpack_public_path__ + "19b2abbc058f7d6317e342832095623a.png";